import { BRAND } from "../../constants/brand";
// BlogDetailPage.jsx
import { Row, Col } from "antd";
import bannerImage3 from "../../assets/incubationBg.png";
import MainLayout from "../../components/layout/main-layout";
import styles from "./index.module.scss";
import { ShareArticleButtons } from "../../components/common/share-article-buttons";

const Imprintusers = () => {
  const title = "{BRAND.short} onboards its largest tranche of waitlist users - Press release May 2025 already in place."

  return (
    <MainLayout>
      <div className={styles.blogDetailPage}>
        {/* Hero Banner */}
        <div
          className={styles.banner}
          style={{
            background: `url(${bannerImage3}) no-repeat center center/cover`,
          }}
        >
          <h1>
            {title}
          </h1>
        </div>

        {/* Author & Content Layout */}
        <Row gutter={[32, 32]} className={styles.mainContent}>
          {/* Sidebar */}
          <Col xs={24} md={7}>
            <div className={styles.sidebar}>
              <div className={styles.authorBox}>
                <div className={styles.authorInfo}>
                  <h3>Press Releases</h3>
                </div>
              </div>
              <div className={styles.postHeader}>
                <div className={styles.topBorder} />
                <p className={styles.publishDate}>Published on May 2025</p>
                <h1 className={styles.postTitle}>
                  {title}
                </h1>
              </div>

              <ShareArticleButtons title />

            </div>
          </Col>

          {/* Blog Content */}
          <Col xs={24} md={17}>
            <div className={styles.articleWrapper}>
              <p>
                {BRAND.domainLabel} is celebrating its mindful mission during Mental
                Health Month by moving to scale up. The platform has seen the
                first opening to users to sign up while also onboarding its
                waitlist users. Collectively it is championing a movement to
                stand up for a better online world. {BRAND.domainLabel} marks a
                fundamental shift for the better in the impact on mental health
                from social media.
              </p>

              <p>
                {BRAND.domainLabel} is a UK tech startup which presents an alternative
                future for social networking, one which is better for mental
                health. Built from the ground up it embodies safety by design.
              </p>

              <p>
                Social media algorithms and trolling are contributing to the
                mental health crisis while social unrest has been perpetuated by
                misinformation online. These combined factors are costing the UK
                taxpayer millions while also resulting in lives lost and an
                ever-increasing burden on NHS resources. {BRAND.domainLabel} is an
                alternative option, one that provides the positives of social
                media expression and connection without the fear and harm to
                one's mental health.
              </p>

              <p>
                Early access begins this week for waiting list members and
                select UK communities. Broader availability is planned for later
                this year.
              </p>
            </div>
          </Col>
        </Row>
      </div>
    </MainLayout>
  );
};

export default Imprintusers;
